import { z } from 'zod';

export const latestAppletDesignVersionNumber = 4 as const;
export const schemaVersionSchema = z.literal(latestAppletDesignVersionNumber);
